import { createMutation } from "@evergis/react-fetching";
import { api as evergisApi } from "../evergis/api";

export const uploadFile = createMutation(
  ({ file, rewrite }: { file: File; rewrite?: boolean }) =>
    async api => {
      const data = await api.file.upload(file, rewrite);

      return {
        data,
      };
    },
  {
    injected: evergisApi,
  },
);

export const uploadFileUrl = createMutation(
  ({ url, rewrite }: { url: string; rewrite?: boolean }) =>
    async api => {
      const { fileId } = await api.file.uploadFile({ url, rewrite });

      return {
        data: fileId,
      };
    },
  {
    injected: evergisApi,
  },
);
